// 알림톡 short-link — Cloud Function 호출 헬퍼
// 백엔드: functions/index.js (resolveShortLink / submitShortLinkResponse / submitShortLinkReview)

const IS_STAGING = process.env.REACT_APP_ENV === 'staging';
const PROJECT_ID = IS_STAGING
  ? 'test-83e89'
  : (process.env.REACT_APP_FIREBASE_PROJECT_ID || 'ieum-8fd99');
const REGION = 'us-central1';

const fnUrl = (name) => `https://${REGION}-${PROJECT_ID}.cloudfunctions.net/${name}`;

// code → SR/고객 컨텍스트 조회 (ri/rd/rc 는 shortlinks, rv 는 serviceRequestId)
export async function resolveShortLink(code) {
  const res = await fetch(`${fnUrl('resolveShortLink')}?code=${encodeURIComponent(code)}`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error === 'not-found'
      ? '링크가 만료되었거나 잘못된 주소입니다.'
      : (data?.error || '링크 정보를 불러오지 못했습니다.'));
  }
  return data;
}

// ri 입력형 응답 제출
export async function submitShortLinkResponse({ code, responseKind, newDate, newTime, memo }) {
  const res = await fetch(fnUrl('submitShortLinkResponse'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code, responseKind, newDate, newTime, memo }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || '제출에 실패했습니다.');
  return data;
}

// 1단계 액션 — 일정 확정 / 상담 취소 (BK 버튼과 동등 처리)
export async function submitShortLinkAction({ code, action }) {
  const res = await fetch(fnUrl('submitShortLinkResponse'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code, action }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || '처리에 실패했습니다.');
  return data;
}

// rv 리뷰 제출
export async function submitShortLinkReview({ serviceRequestId, rating, memo }) {
  const res = await fetch(fnUrl('submitShortLinkReview'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ serviceRequestId, rating, memo }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error === 'already-reviewed'
      ? '이미 평가를 남기셨습니다.'
      : (data?.error || '평가 제출에 실패했습니다.'));
  }
  return data;
}
